var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeeMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40Z",
    fill: "#FF66C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9016 35.3927H44.5944V21.0974C44.5944 18.8346 42.7687 17 40.5059 17C38.2432 17 36.4185 18.8346 36.4185 21.0984V35.4026H22.1043C19.8415 35.4026 18.002 37.2372 18.003 39.501C18.002 40.6319 18.4589 41.6686 19.1993 42.409C19.9407 43.1514 20.9635 43.6202 22.0934 43.6202H36.4185V57.9046C36.4185 59.0365 36.8675 60.0613 37.6088 60.8007C38.3502 61.5421 39.3701 62.001 40.502 62.001C42.7638 62.001 44.5944 60.1664 44.5944 57.9046V43.6192H58.9016C61.1644 43.6192 62.999 41.7687 62.998 39.506C62.997 37.2442 61.1624 35.3927 58.9016 35.3927Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeMore);
export default __webpack_public_path__ + "static/media/See More.64ed17c779253400e969668d6b39f774.svg";
export { ForwardRef as ReactComponent };